export class HttpUserKeyRepository {
    constructor(http, localStorage, logger) {
        this.http = http;
        this.localStorage = localStorage;
        this.logger = logger;
    }
    async getPrivateKeysByUserId(companyId, userId) {
        try {
            this.logger.logInformation('HTTP User Key Repository: Getting encrypted user key pairs...');
            const result = await this.http.get('private-keys');
            // save in case of a future api call error
            try {
                this.localStorage.set(this.getLocalStorageKey(companyId, userId), result);
            }
            catch (ex) {
                this.logger.logWarning(`HTTP User Key Repository: ${ex}`);
            }
            this.logger.logInformation('HTTP User Key Repository: Key pairs successfully loaded.');
            return result;
        }
        catch (ex) {
            this.logger.logWarning(`HTTP User Key Repository: ${ex}`);
            // return last known result
            try {
                const lastResult = this.localStorage.get(this.getLocalStorageKey(companyId, userId));
                if (lastResult !== null) {
                    this.logger.logInformation('HTTP User Key Repository: Returning last known result.');
                    return lastResult;
                }
            }
            catch (ex) {
                this.logger.logWarning(`HTTP User Key Repository: ${ex}`);
            }
            throw ex;
        }
    }
    resetUserKeysInLocalStorage(companyId, userId) {
        this.localStorage.remove(this.getLocalStorageKey(companyId, userId));
    }
    addPrivateKey(data) {
        return this.http.post('private-keys', data);
    }
    getLocalStorageKey(companyId, userId) {
        return `ZeroTrust_PrivateKeys_${companyId}_${userId}`;
    }
}
